import { FC } from "react";
import CountUp from "react-countup";

type UserCounterProps = {
    userCount: number;
    onClick: () => void;
}
export const UserCounter: FC<UserCounterProps> = ({userCount, onClick}) => {
    return (
        <div className="flex flex-col items-center justify-center z-50 bg-darkerBlue py-4 px-4 w-[320px] rounded-2xl shadow-lg max-w-sm mx-auto my-4 border-2 border-primaryOrange hover:shadow-2xl transition-all duration-500 ease-in-out">
          <h2 className="text-4xl font-extrabold text-primaryBlack mb-2">
            <CountUp end={userCount} duration={3} />+
          </h2>
          <p className="text-base text-primaryGrey text-center leading-snug">
            People have already joined <span className="font-semibold text-primaryOrange">Greetli</span> 
            <span className="text-primaryGrey  font-semibold"> You’re on the road to making your life easier! 🚀</span>
          </p>
          <button
            className="mt-4 px-5 py-3 bg-darkOrange text-primaryWhite text-base font-semibold rounded-xl hover:bg-lightOrange transition-all duration-300 ease-in-out"
            onClick={onClick}
          >
            Pre-Register Now 🚀
          </button>
        </div>
      );
}